import * as errorReporting from './sentry';

export default errorReporting;
